import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useViewPermissionsList } from '../../hooks/auth/permissionslist';
import { userPermssionsStore } from '../../store/permissions.store';

const ProtectedRoute = ({ children, requiredPermission, requiredResource }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const setPermissions = userPermssionsStore((state) => state.setPermissions);
  const clearPermissions = userPermssionsStore((state) => state.clearPermissions);
  const permissionsLoaded = userPermssionsStore((state) => state.permissionsLoaded);
  const hasPermissions = userPermssionsStore((state) => state.hasPermissions);
  const canAccessResource = userPermssionsStore((state) => state.canAccessResource);

  const { data: permissionResponse, isLoading: isPermissionsLoading } = useViewPermissionsList({
    enabled: isAuthenticated,
  });


  console.log("permissin list", permissionResponse)

  useEffect(() => {
    if (!isAuthenticated) {
      clearPermissions();
      return;
    }

    if (Array.isArray(permissionResponse?.data)) {
      setPermissions(permissionResponse.data);
    }
  }, [isAuthenticated, permissionResponse, setPermissions, clearPermissions]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isPermissionsLoading || !permissionsLoaded) {
    return <div>Loading...</div>;
  }

  if (requiredPermission && !hasPermissions(requiredPermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredResource && !canAccessResource(requiredResource)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;